<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Save"
      back-button-text="Previous"
      class="mb-3"
      @on-complete="formSubmitted"
    >
      <!-- accoint details tab -->
      <tab-content
        title="Updating User"
        icon="feather icon-file-text"
        :before-change="onSubmit"
      >
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <!-- Name -->
            <b-col md="6">
              <b-form-group label="First Name *" label-for="firstName">
                <validation-provider
                  #default="{ errors }"
                  name="firstName"
                  rules="required"
                >
                  <b-form-input
                    id="firstName"
                    v-model="requestData.firstName"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="First Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col md="6">
              <b-form-group label="Last Name *" label-for="lastName">
                <validation-provider
                  #default="{ errors }"
                  name="lastName"
                  rules="required"
                >
                  <b-form-input
                    id="lastName"
                    v-model="requestData.lastName"
                    type="text"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Last Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Phone Number *" label-for="Phone Number">
                <validation-provider
                  #default="{ errors }"
                  rules="required"
                  name="Phone Number "
                >
                  <b-form-input
                    id="Phone Number"
                    v-model="requestData.PhoneNumber"
                    type="number"
                    placeholder="Phone Number starting with 251"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Access Type  -->
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Access Type"
                rules="required"
              >
                <b-form-group
                  label="Access Type *"
                  label-for="Access Type"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="requestData.accessType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="accessTypes"
                    label="name"
                    :clearable="true"
                    input-id="accessTypes"
                    @input="handelAccessTypeChange"
                  >
                    <template #option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>

                    <template #selected-option="{ name }">
                      <span class="ml-50 align-middle"> {{ name }}</span>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <!-- Role -->
            <b-col md="6">
              <b-form-group label="Role *" label-for="Role">
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  rules="required"
                >
                  <v-select
                    v-model="requestData.roleId"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="allRoles"
                    label="name"
                    :clearable="true"
                    input-id="roles"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Full Access To All merchants -->
          <b-card
            border-variant="secondary"
            bg-variant="transparent"
            class="shadow-none"
          >
            <b-card-text>
              <b-row>
                <!-- Companies  -->
                <!-- <b-col md="3">
                  <validation-provider #default="{ errors }" name="Companies ">
                    <b-form-group label="Companies *" label-for="Companies">
                      <v-select
                        v-model="requestData.selectedCompanId"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="companyIds"
                        label="name"
                        :clearable="true"
                        input-id="companies"
                        @input="handleCompanySelection()"
                      >
                        <template #option="{ name }">
                          <span class="ml-50 align-middle"> {{ name }}</span>
                        </template>

                        <template #selected-option="{ name }">
                          <span class="ml-50 align-middle"> {{ name }}</span>
                        </template>
                      </v-select>
                    </b-form-group>
                  </validation-provider>
                </b-col> -->
                <b-col md="6">
                  <b-card-title>
                    <b-row style="padding-left: 10px">
                      <b-form-checkbox
                        v-model="merchantIds.isChecked"
                        :indeterminate.sync="merchantIds.isIndeterminate"
                        @change="handelChekAll(merchantIds.isChecked)"
                      >
                        All Merchants
                      </b-form-checkbox>
                    </b-row>
                  </b-card-title>
                  <div v-for="(value, index) in merchantIds" :key="index">
                    <b-row>
                      <b-col md="4">
                        {{ value.name }}
                      </b-col>
                      <b-col md="8">
                        <b-form-checkbox
                          v-model="value.isChecked"
                          :indeterminate.sync="value.isIndeterminate"
                          @change="handleCheckAllChangemerchantIds(value)"
                        >
                          Full Access
                        </b-form-checkbox>
                        <b-form-group
                          v-model="checkedmerchantIds"
                          label-for="isCheked"
                        >
                          <b-form-checkbox
                            v-for="(item, i) in value.merchants"
                            :key="i"
                            v-model="item.isChecked"
                            :label="item.id"
                            @change="
                              handleCheckedChangemerchantIds(item, value)
                            "
                          >
                            {{ item.name }}
                          </b-form-checkbox>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
                <!-- Default Merchant  -->
                <b-col md="3">
                  <validation-provider
                    #default="{ errors }"
                    name="Default Merchant "
                    rules="required"
                  >
                    <b-form-group
                      label="Default Merchant *"
                      label-for="Default Merchant"
                      :state="errors.length > 0 ? false : null"
                    >
                      <v-select
                        v-model="requestData.defaultMerchantId"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="defaultMerchantIds"
                        label="name"
                        :clearable="true"
                        input-id="accessTypes"
                      >
                        <template #option="{ name }">
                          <span class="ml-50 align-middle"> {{ name }}</span>
                        </template>

                        <template #selected-option="{ name }">
                          <span class="ml-50 align-middle"> {{ name }}</span>
                        </template>
                      </v-select>
                      <b-form-invalid-feedback
                        :state="errors.length > 0 ? false : null"
                      >
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </validation-observer>
      </tab-content>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from "@axios";
import vSelect from "vue-select";
import { required, email } from "@validations";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BOverlay,
  BCardTitle,
  BCard,
  BCardText,
  BFormInvalidFeedback,
} from "bootstrap-vue";

export default {
  name: "AddAdvancePayment",
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BFormCheckbox,
    BOverlay,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BCardTitle,
    BCard,
    BCardText,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      isLoading: false,
      requestData: {
        firstName: "",
        lastName: "",
        PhoneNumber: "",
        roleId: null,
        accessType: null,
        merchantIds: [],
        defaultMerchantId: null,
      },
      required,
      email,
      checkedmerchantIds: [],
      allmerchantIdsCounter: 0,
      // Options
      roles: [],
      allRoles: [],
      accessTypes: [
        { id: 1, name: "GateWay" },
        { id: 2, name: "Merchant" },
      ],
      merchantIds: [], // JSON.parse(localStorage.getItem('companies')),
      allMerchantIds: [], // JSON.parse(localStorage.getItem('companies')),
      companyIds: [], // JSON.parse(localStorage.getItem('companies')).filter(m => m.id),
      defaultMerchantIds: [],
    };
  },
  created() {
    this.fetchUserData();
    this.fetchData();
    this.merchantIds.isChecked = false;
    this.merchantIds.isIndeterminate = false;
    this.merchantIds.forEach((res) => {
      res.isChecked = false;
      res.isIndeterminate = false;
      res.merchants.forEach((val) => {
        val.isChecked = false;
      });
    });
  },
  methods: {
    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Data Submitted",
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
    defaultData() {
      this.allMerchantIds.isChecked = true;
      this.allMerchantIds.isIndeterminate = false;
      this.allMerchantIds.forEach((res) => {
        res.isChecked = true;
        res.isIndeterminate = false;
        res.merchants.forEach((val) => {
          val.isChecked = true;
          this.checkedmerchantIds.push(val.id);
          this.defaultMerchantIds.push(val);
          this.allmerchantIdsCounter += 1;
        });
      });
      this.chekedStatus();
      this.merchantIds.forEach((res) => {
        res.isChecked = true;
        res.isIndeterminate = false;
        res.merchants.forEach((val) => {
          val.isChecked = true;
          // this.checkedmerchantIds.push(val.id)
          // this.defaultMerchantIds.push(val)
          // this.allmerchantIdsCounter += 1
        });
      });
    },
    // merchantIds
    handelChekAll(row) {
      if (!row) {
        this.merchantIds.forEach((res) => {
          res.isChecked = false;
          res.isIndeterminate = false;
          if (this.checkedmerchantIds.find((el) => el === res.id)) {
            const arr = this.checkedmerchantIds.find((el) => el === res.id);
            this.checkedmerchantIds.splice(
              this.checkedmerchantIds.indexOf(arr),
              1,
            );
          }
          res.merchants.forEach((val) => {
            val.isChecked = false;
            if (this.checkedmerchantIds.find((el) => el === val.id)) {
              const arr = this.checkedmerchantIds.find((el) => el === val.id);
              this.checkedmerchantIds.splice(
                this.checkedmerchantIds.indexOf(arr),
                1,
              );
            }
          });
        });
        this.merchantIds.isIndeterminate = false;
      } else {
        this.merchantIds.forEach((res) => {
          res.isChecked = true;
          res.isIndeterminate = false;
          res.merchants.forEach((val) => {
            val.isChecked = true;
            this.checkedmerchantIds.push(val.id);
          });
        });
        this.merchantIds.isIndeterminate = false;
      }
      this.checkedmerchantIds = [...new Set(this.checkedmerchantIds)];
      this.setDefaultMerchantIds();
    },
    handleCheckAllChangemerchantIds(val) {
      if (!val.isChecked) {
        val.isChecked = false;
        val.isIndeterminate = false;
        val.merchants.forEach((res) => {
          res.isChecked = false;
          if (this.checkedmerchantIds.find((el) => el === res.id)) {
            const arr = this.checkedmerchantIds.find((el) => el === res.id);
            this.checkedmerchantIds.splice(
              this.checkedmerchantIds.indexOf(arr),
              1,
            );
          }
        });
      } else {
        val.isChecked = true;
        val.isIndeterminate = false;
        val.merchants.forEach((res) => {
          res.isChecked = true;
          this.checkedmerchantIds.push(res.id);
        });
      }
      this.chekedStatus();
    },
    handleCheckedChangemerchantIds(role, privileges) {
      let count = 0;
      privileges.merchants.forEach((res) => {
        if (res.isChecked) count += 1;
      });
      if (role.isChecked) {
        this.checkedmerchantIds.push(role.id);
      } else {
        const arr = this.checkedmerchantIds.find((el) => el === role.id);
        this.checkedmerchantIds.splice(this.checkedmerchantIds.indexOf(arr), 1);
      }
      if (privileges.merchants.length === count) {
        privileges.isChecked = true;
        privileges.isIndeterminate = false;
      } else if (count === 0) {
        privileges.isChecked = false;
        privileges.isIndeterminate = false;
      } else {
        privileges.isChecked = false;
        privileges.isIndeterminate = true;
      }
      this.chekedStatus();
    },
    chekedStatus() {
      // Remove Duplication
      this.checkedmerchantIds = [...new Set(this.checkedmerchantIds)];
      if (this.allmerchantIdsCounter === this.checkedmerchantIds.length) {
        this.merchantIds.isChecked = true;
        this.merchantIds.isIndeterminate = false;
      } else if (this.checkedmerchantIds.length > 0) {
        this.merchantIds.isIndeterminate = true;
        this.merchantIds.isChecked = false;
      } else if (this.checkedmerchantIds.length === 0) {
        this.merchantIds.isChecked = false;
        this.merchantIds.isIndeterminate = false;
      }
      this.setDefaultMerchantIds();
    },
    setDefaultMerchantIds() {
      this.defaultMerchantIds = [];
      this.checkedmerchantIds.forEach((res) => {
        // eslint-disable-next-line no-shadow
        this.merchantIds.forEach((val) => {
          val.merchants.forEach((item) => {
            if (res === item.id) {
              this.defaultMerchantIds.push(item);
            }
          });
        });
      });
      this.defaultMerchantIds = [...new Set(this.defaultMerchantIds)];
    },
    getDefault() {
      this.merchantIds.forEach((value) => {
        value.merchants.forEach((item) => {
          if (item.id === this.requestData.defaultMerchantId) {
            this.requestData.defaultMerchantId = item;
          }
        });
      });
    },
    handelAccessTypeChange() {
      if (this.requestData.accessType.id === 2) {
        this.merchantIds = null;
        this.requestData.defaultMerchantId = null;
      } else {
        this.merchantIds = this.allMerchantIds;
        this.defaultData();
      }
    },
    handleCompanySelection() {
      this.merchantIds = this.allMerchantIds.filter(
        (c) => c.id === this.requestData.selectedCompanId.id,
      );
      this.checkedmerchantIds = [];
      this.merchantIds[0].isChecked = true;
      this.merchantIds[0].isIndeterminate = false;
      this.merchantIds[0].merchants.forEach((res) => {
        res.isChecked = true;
        this.checkedmerchantIds.push(res.id);
      });
      this.chekedStatus();
    },
    // API Call
    fetchUserData() {
      this.$store.dispatch("config/getActionPrivilege", "Account-Update");
      this.isLoading = true;
      axios
        .get("/Merchant/api/V1.0/Merchants/GetGroupedMerchants")
        .then((res1) => {
          this.allMerchantIds = res1.companies;
          this.merchantIds = res1.companies;
          this.companyIds = res1.companies.filter((m) => m.id);
          axios
            .get(`/User/api/V1.0/Account/GetById?id=${this.$route.params.id}`)
            .then((res) => {
              this.requestData = res.user;
              this.requestData.roleId = res.user.role;
              console.log("info", res.user.accessType);
              if (res.user.accessType === 2) {
                this.requestData.selectedCompanId = this.companyIds.filter(
                  (c) => c.id === res.user.companyId,
                );
                this.merchantIds = this.allMerchantIds.filter(
                  (c) => c.id === res.user.companyId,
                );
              }
              this.roles = this.allRoles.filter(
                (role) => role.accessType === res.user.accessType,
              );
              this.requestData.accessType = this.accessTypes.find(
                (a) => a.id === res.user.accessType,
              );
              let counter = 0;
              this.merchantIds.forEach((value) => {
                this.allmerchantIdsCounter += value.merchants.length;
              });
              this.merchantIds.forEach((value) => {
                value.merchants.forEach((val) => {
                  if (val.id === res.user.defaultMerchantId) {
                    this.requestData.defaultMerchantId = val;
                  }
                  res.user.merchants.forEach((item) => {
                    if (val.id === item.id) {
                      val.isChecked = true;
                      counter += 1;
                      this.checkedmerchantIds.push(val.id);
                    }
                  });
                });

                if (value.merchants.length === counter) {
                  value.isChecked = true;
                  value.isIndeterminate = false;
                } else if (counter === 0) {
                  value.isChecked = false;
                  value.isIndeterminate = false;
                } else {
                  value.isChecked = false;
                  value.isIndeterminate = true;
                }
                counter = 0;
              });
              this.chekedStatus();
            });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    fetchData() {
      this.$store.dispatch("config/getActionPrivilege", "Account-Update");
      this.isLoading = true;
      axios
        .get("/User/api/V1.0/Role/GetAll")
        .then((res) => {
          this.isLoading = false;
          this.allRoles = res.roles;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then((success) => {
          if (success) {
            this.requestData.merchantIds = this.checkedmerchantIds;
            this.requestData.roleId = this.requestData.roleId.id;
            this.requestData.defaultMerchantId =
              this.requestData.defaultMerchantId.id;
            this.requestData.accessType = this.requestData.accessType.id;
            delete this.requestData.role;
            delete this.requestData.merchants;
            this.isLoading = true;
            axios
              .put("/User/api/V1.0/Account/Update", this.requestData)
              .then((res) => {
                if (res.status) {
                  this.isLoading = false;
                  this.$router.push("/account-Management/users");
                  resolve(true);
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Error",
                      icon: "BellIcon",
                      variant: "danger",
                      text: `${res.message}`,
                    },
                  });
                  this.getDefault();
                  this.isLoading = false;
                }
              })
              .catch((err) => {
                reject(err);
                this.getDefault();
                this.isLoading = false;
              });
          } else {
            reject();
          }
        });
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
